export default __webpack_public_path__ + "static/media/K2500Gallery1.0865d7b9.jpg";